import { useContext, useEffect, useState } from 'react';
import './styles.css';
import { Button } from 'primereact/button';
import 'react-tabs/style/react-tabs.css';
import { useHistory } from 'react-router-dom';

import Paper from '@material-ui/core/Paper';

import { Link } from 'react-router-dom';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from '../../components/ui/select';
import { InputIcon } from '../../components/ui/input';
import {
  FilePlusIcon,
  MagnifyingGlassIcon,
  TrashIcon,
} from '@radix-ui/react-icons';

import api from '../../services/api';
import { format } from 'date-fns';
import { ToastAction } from '../../components/ui/toast';
import { useToast } from '../../components/ui/use-toast';
import UserContext from 'src/context/UserContext';
import { stepsDocumentosAta } from '../Tour/steps';
import { useTour } from '@reactour/tour';
import Tour from '../Tour';

export default function DocumentosAta(props) {
  const history = useHistory();
  const { userData } = useContext(UserContext);

  const [atas, setAtas] = useState([]);
  const [atasFiltered, setAtasFiltered] = useState([]);
  const [setUser] = useState({});
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const { setSteps } = useTour();

  useEffect(() => {
    setSteps(stepsDocumentosAta);
  });

  useEffect(() => {
    async function perfilInfoHandler() {
      try {
        let token = localStorage.getItem('auth-token');
        const userRes = await api.get('/api/user/perfil', {
          headers: { 'x-auth-token': token },
        });
        const ataRes = await api.get('/api/ata/minhas', {
          headers: { 'x-auth-token': token },
        });
        setUser(userRes.data);
        setAtas(ataRes.data);
        setAtasFiltered(ataRes.data);
      } catch (err) {
        console.log(err);
      }
    }

    perfilInfoHandler();
  }, [setUser]);

  const CustomPaper = () => {
    const inicialNome = (owner) => {
      let listaNome = owner.split(' ');
      let tamanhoListaNome = listaNome.length;
      let sigla = listaNome[0][0] + listaNome[tamanhoListaNome - 1][0];

      return sigla;
    };

    const { toast } = useToast();

    useEffect(() => {
      if (shouldRedirect) {
        console.log('Redirecionando...');
        toast({
          title: 'Documento movido para lixeira',
          description: 'Para recuperar ou mover o documento acesse a lixera',
        });
        setShouldRedirect(false);

        document.body.classList.add('loading-cursor');
        setTimeout(() => {
          history.go(0); //recarregando a pagina
        }, 1250);

        window.onload = function () {
          document.body.classList.remove('loading-cursor');
        };
      }
    }, [toast]);

    const handleRestaurarClick = async (ataId) => {
      try {
        const updatedAtas = atas.map((item) =>
          item._id === ataId ? { ...item, trash: true } : item,
        );
        setAtas(updatedAtas);

        await api.put(`/api/atas/${ataId}`);

        // Adiciona a notificação de sucesso
        setShouldRedirect(true);
        toast({
          variant: 'default',
          title: 'Documento movido para lixeira',
          description: 'Para recuperar ou mover o documento acesse a lixera',
        });
      } catch (error) {
        console.error('Erro ao restaurar ata:', error);

        // Adiciona a notificação de erro
        toast({
          title: 'Erro ao encaminhar a ata para lixeira',
          description: 'Documento foi permanentemente removido',
          action: <ToastAction altText="Desfazer">Desfazer</ToastAction>,
        });
      }
    };

    return (
      <div
        elevation={24}
        style={{
          display: 'flex',
          marginBottom: '30px',
          flexWrap: 'wrap',
          gap: 14,
          paddingRight: '110px',
          paddingLeft: '180px',
        }}
      >
        {atasFiltered
          .sort((a, b) => {
            if (projetoSelecionado === 'maisRecente') {
              return new Date(b.criadoEm) - new Date(a.criadoEm);
            } else if (projetoSelecionado === 'maisAntiga') {
              return new Date(a.criadoEm) - new Date(b.criadoEm);
            }
            if (a[projetoSelecionado] < b[projetoSelecionado]) return -1;
            if (a[projetoSelecionado] > b[projetoSelecionado]) return 1;

            return 0;
          })
          .map((ata) => (
            <div
              style={{
                cursor: 'pointer',
              }}
              onClick={() => history.push('/nova-ata/' + ata._id)}
            >
              <Paper
                elevation={2}
                className="suasatas"
                style={{
                  color: '#3900DB',
                  height: '150px',
                  fontSize: '1rem',

                  fontWeight: 700,
                  width: '15rem',
                  minHeight: '103px',
                  maxHeight: '120px',

                  //   lineHeight: "1.5",
                  letterSpacing: '0.00938em',
                  margin: '0px',
                  borderRadius: '8px',
                  background: '#FAFAFA',
                  boxSshadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
                  marginLeft: '15px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    marginLeft: '15px',
                    margintop: '200px',
                    overflowY: 'auto',
                    alignItems: 'center',
                    width: '190px',
                    height: '50px',
                  }}
                >
                  {ata.cliente}
                </div>

                <div
                  className="suasatas"
                  style={{
                    color: '#000',
                    height: '80pl',
                    fontSize: '18px',

                    fontWeight: 500,
                    lineHeight: '1.5',
                    letterSpacing: '0.00938em',
                    margin: '0px',
                    justifyContent: 'start',
                    marginLeft: '15px',
                  }}
                >
                  {ata.projeto}
                </div>
                <div
                  className="suasatas"
                  style={{
                    color: '#858585',
                    display: 'flex',
                    height: '80pl',
                    fontSize: '14px',

                    fontWeight: 400,
                    fontStyle: 'italic',
                    lineHeight: '1.5',
                    letterSpacing: '0.00938em',
                    margin: '0px',
                    marginLeft: '15px',
                    marginBottom: '-4px',
                  }}
                >
                  {' '}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    viewBox="0 0 36 36"
                    fill="none"
                  >
                    <circle cx="18" cy="18" r="18" fill="#3E2388" />
                  </svg>
                  <div
                    style={{
                      marginTop: '-40px',
                      marginLeft: '-21px',

                      color: 'white',
                      fontSize: '13px',
                      fontStyle: 'normal',
                      maxHeight: '60px',
                    }}
                  >
                    {inicialNome(ata.owner.nome)}
                  </div>
                  <div
                    elevation={24}
                    style={{
                      marginLeft: '20px',
                      width: '20%',
                      display: 'flex',
                      marginTop: '-2px',

                      boxSshadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
                    }}
                  >
                    {format(new Date(ata.criadoEm), 'dd/MM/yyyy')}
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      marginLeft: '110px',
                      marginTop: '-60px',
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      onClick={(e, ataId) => {
                        e.stopPropagation();
                        handleRestaurarClick(ata._id);
                      }}
                    >
                      <path
                        d="M7 12.6C3.913 12.6 1.4 10.087 1.4 7C1.4 3.913 3.913 1.4 7 1.4C10.087 1.4 12.6 3.913 12.6 7C12.6 10.087 10.087 12.6 7 12.6ZM7 0C3.129 0 0 3.129 0 7C0 10.871 3.129 14 7 14C10.871 14 14 10.871 14 7C14 3.129 10.871 0 7 0ZM8.813 4.2L7 6.013L5.187 4.2L4.2 5.187L6.013 7L4.2 8.813L5.187 9.8L7 7.987L8.813 9.8L9.8 8.813L7.987 7L9.8 5.187L8.813 4.2Z"
                        fill="#EC0000"
                      />
                    </svg>
                  </div>
                </div>
              </Paper>
            </div>
          ))}
      </div>
    );
  };
  const handleClick = () => {
    navigator('/editar-ata');
  };
  const DocumentosAtas = () => {
    return (
      <div
        style={{
          flexDirection: 'column',
          alignItems: 'center',
          width: '77vw',
          overflow: 'auto',
          height: '50%',
          position: 'fixed',
          marginTop: '300px',
        }}
      >
        {' '}
        <div onClick={handleClick}></div>
        {[...Array(1)].map((_, index) => (
          <CustomPaper key={index} />
        ))}
      </div>
    );
  };

  const [projetoSelecionado, setProjetoSelecionado] = useState('');

  const [termoPesquisa, setTermoPesquisa] = useState('');

  const handleSelecao = (value) => {
    setProjetoSelecionado(value);
  };

  const [projeto, setNomeProjetos] = useState([]);
  const [projetoSelected, setProjetoSelected] = useState('');

  const handleChangeProjeto = (value) => {
    setProjetoSelected(value);
    if (value === '0') {
      return setAtasFiltered(atas);
    }
    console.log(value);
    setAtasFiltered(
      atas.filter((ata) =>
        ata?.projeto.toLowerCase().includes(value.toLowerCase()),
      ),
    );
  };

  const [cliente, setCliente] = useState([]);
  const [clienteSelected, setClienteSelected] = useState('');

  const handleChangeCliente = (value) => {
    setClienteSelected(value);
    if (value === '0') {
      return setAtasFiltered(atas);
    }
    setAtasFiltered(
      atas.filter((ata) =>
        ata?.cliente.toLowerCase().includes(value.toLowerCase()),
      ),
    );
  };

  const [colaboradores, setColaboradores] = useState([]);
  const [colaboradoresSelected, setColaboradoresSelected] = useState('');

  const handleChangeColaboradores = (value) => {
    setColaboradoresSelected(value);
    if (value === '0') {
      return setAtasFiltered(atas);
    }

    setAtasFiltered(
      atas.filter((ata) =>
        ata?.owner.nome.toLowerCase().includes(value.toLowerCase()),
      ),
    );
  };

  useEffect(() => {
    const buscarProjetosClientes = async () => {
      if (userData.user) {
        let token = localStorage.getItem('auth-token');
        try {
          const response = await api.get('/api/buscarProjetosUsuario', {
            params: { id_colaborador: userData.user.id_colaborador },
            headers: { 'x-auth-token': token },
          });

          setNomeProjetos(response.data.resultSplit);
          setCliente(response.data.clientes);
        } catch (error) {
          console.error('Erro ao buscar Projetos:', error);
        }
      }
    };

    buscarProjetosClientes();
  }, [userData.user]);

  useEffect(() => {
    const buscarColaboradores = async () => {
      try {
        let token = localStorage.getItem('auth-token');
        const response = await api.get('/api/ata/listarTodosUsuarios', {
          headers: { 'x-auth-token': token },
        });

        setColaboradores(response.data);
      } catch (error) {
        console.error('Erro ao buscar Colaboradores:', error);
      }
    };

    buscarColaboradores();
  }, []);

  const handleTermoPesquisaChange = (event) => {
    setTermoPesquisa(event.target.value);
    setAtasFiltered(
      atas.filter(
        (ata) =>
          ata?.projeto
            .toLowerCase()
            .includes(event.target.value.toLowerCase()) ||
          ata?.cliente.toLowerCase().includes(event.target.value.toLowerCase()),
      ),
    );
  };
  return (
    <div style={{ overflow: 'hidden' }}>
      <nav
        className="navigation"
        style={{
          marginLeft: '15%',
          marginTop: '100px',
          marginBottom: '-80px',
        }}
      >
        <ul>
          <li>
            <a href="/perfil">Home</a>
          </li>
          <li>/</li>
          <li>
            <a href="/documentos-ata">Atas</a>
          </li>
          <li>/</li>
          <li>
            <p>Documentos</p>
          </li>
        </ul>
      </nav>

      <div
        style={{
          width: '100vw',
          height: '84vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: '5%',
        }}
      >
        <p
          className="tituloDocumentosAta"
          style={{
            fontSize: '35px',
            fontStyle: 'normal',
            fontWeight: '700',
            color: '#00293B',
          }}
        >
          Documentos
        </p>

        <div
          style={{
            borderBottom: '2px solid rgba(0, 105, 152, 0.55)',
            width: '70%',
            display: 'flex',
            justifyContent: 'center',
          }}
        ></div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            height: '755px',
          }}
        >
          <p style={{ marginTop: '50px', marginBottom: '-50px' }}>
            Filtrar por:
          </p>
          <div
            style={{
              display: 'flex',
              gap: '16px',
              marginRight: '100px',
              marginTop: '60px',
            }}
          >
            <Select value={projetoSelected} onValueChange={handleChangeProjeto}>
              <SelectTrigger className="w-[180px] projetosFiltro">
                <SelectValue placeholder="Projetos" />
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  <SelectLabel>Projetos</SelectLabel>
                  <SelectItem key={0} value="0">
                    Selecione o Projeto
                  </SelectItem>
                  {projeto.map((projeto) => (
                    <SelectItem
                      key={projeto.nome_projeto}
                      value={projeto.nome_projeto}
                    >
                      {projeto.nome_projeto}
                    </SelectItem>
                  ))}
                </SelectGroup>
              </SelectContent>
            </Select>

            <Select value={clienteSelected} onValueChange={handleChangeCliente}>
              <SelectTrigger className="w-[180px] clientesFiltro">
                <SelectValue placeholder="Clientes" />
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  <SelectLabel>Clientes</SelectLabel>
                  <SelectItem key={0} value="0">
                    Selecione o Cliente
                  </SelectItem>

                  {cliente.map((cliente) => (
                    <SelectItem
                      key={cliente.nome_cliente}
                      value={cliente.nome_cliente}
                    >
                      {cliente.nome_cliente}
                    </SelectItem>
                  ))}
                </SelectGroup>
              </SelectContent>
            </Select>

            <Select
              value={colaboradoresSelected}
              onValueChange={handleChangeColaboradores}
            >
              <SelectTrigger className="w-[180px] autorFiltro">
                <SelectValue placeholder="Autor" />
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  <SelectLabel>Autor</SelectLabel>
                  <SelectItem key={0} value="0">
                    Selecione o Autor
                  </SelectItem>
                  {colaboradores.map((colaborador) => (
                    <SelectItem key={colaborador.nome} value={colaborador.nome}>
                      {colaborador.nome}
                    </SelectItem>
                  ))}
                </SelectGroup>
              </SelectContent>
            </Select>

            <Link to="/template-documentos">
              <Button
                asChild
                icon={<FilePlusIcon className="h-[18px] w-[16px]" />}
                className="p-button-outlined p-button-primary buttonNovoDocumento"
                variant="outline"
                style={{ height: '35px' }}
              >
                Novo documento
              </Button>
            </Link>

            <Link to="/atas-excluidas">
              <Button
                icon={<TrashIcon className="h-[18px] w-[16px]" />}
                className="p-button-outlined p-button-primary buttonLixeira "
                variant="outline"
                style={{
                  color: 'red',
                  fontFamily: 'Satoshi',
                  fontWeight: 500,
                  height: '35px',
                }}
              >
                Lixeira
              </Button>
            </Link>
          </div>

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '200px',
              gap: '16px',
              marginRight: '600px',
              marginTop: '8px',
            }}
          >
            <Select onValueChange={handleSelecao}>
              <SelectTrigger className="w-[180px] buttonOrdenarPor">
                <SelectValue placeholder="Ordenar por" />
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  <SelectItem value="projeto">
                    Ordem alfábetica de Projeto
                  </SelectItem>
                  <SelectItem value="cliente">
                    Ordem alfábetica de Cliente
                  </SelectItem>
                  <SelectItem value="maisRecente">Data mais recente</SelectItem>
                  <SelectItem value="maisAntiga">Data mais antiga</SelectItem>
                </SelectGroup>
              </SelectContent>
            </Select>

            <InputIcon
              className="p-1  w-200 campoPesquisar"
              value={termoPesquisa}
              onChange={handleTermoPesquisaChange}
              icon={<MagnifyingGlassIcon className="h-[18px] w-[16px]" />}
            />
          </div>
        </div>

        <DocumentosAtas />
        <Tour></Tour>
        <br></br>
        <br></br>
      </div>
    </div>
  );
}
